module.exports = __webpack_public_path__ + "img/LUB00148.601aea90.png";